import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const SearchRow = ({
  href,
  target,
  hitKind,
  children,
  className,
  hit,
  index,
  onClick
}) => /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
  href: href,
  className: classNames(style.searchRow, className),
  target: target,
  "data-test-id": "search-row-".concat(hitKind)
}, index !== undefined && hit !== undefined ? {
  'data-insights-object-id': hit.objectID,
  'data-insights-position': index + 1
} : {}), {}, {
  onClick: onClick,
  children: children
}));

export default SearchRow;